
export default {
  props: ['url'],
  data() {
    return {
      page: '',
    };
  },
  computed: {
    user() {
      return this.$store.state.user;
    },
    isAuthenticated() {
      return this.$store.getters.isAuthenticated;
    },
    loading() {
      return this.$store.state.loading;
    },
    isEnabled() {
      return !!this.name && !!this.email && !!this.phone && !!this.message;
    },
  },
  methods: {
    GetPage(pageUrl) {
      const app = this;
      app.$store.getters.ax.post('pages/api/pages/index', { url: pageUrl })
        .then((response) => {
          if (response.data.page) {
            app.page = response.data.page;
          }
        });
    },
  },
  mounted() {
    console.log(this.url);
    this.GetPage(this.url);
  },
};
